import { render, staticRenderFns } from "./info-brinde.vue?vue&type=template&id=56a72628&scoped=true&"
import script from "./info-brinde.vue?vue&type=script&lang=js&"
export * from "./info-brinde.vue?vue&type=script&lang=js&"
import style0 from "./info-brinde.vue?vue&type=style&index=0&id=56a72628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a72628",
  null
  
)

export default component.exports